import { useEffect, useRef } from 'react';
import { LottieLoader } from '../components/loader'
import useRouterRedirection from '../hooks/use-router-redirection';
import { useAppDispatch, useAppSelector } from '../redux/hook';
import { getSpcpName, resetAuthData } from '../redux/slices/authentication-slice';
import { AppDispatch } from '../redux/store';

const RESOLVE_SINGPASS_TYPE_TIMEOUT_MS = 30_000; // 30 seconds
const SESSION_TIMEOUT_MESSAGE =
  'Your session could not be verified in time. You will be logged out. Please sign in again to continue.';

function logoutAndRedirect(dispatch: AppDispatch, alertMessage?: string) {
  if (alertMessage) {
    window.alert(alertMessage);
  }
  dispatch(resetAuthData());
  window.location.href = '/transfer/logout';
}

function Auth() {
  const AppDispatch = useAppDispatch();
  const isAuthenticated = useAppSelector((state) => state.auth.AuthenticationSlice.isAuthenticated);
  const singPassType = useAppSelector((state) => state.auth.AuthenticationSlice.singPassType);
  const singpassToken = useAppSelector((state) => state.auth.AuthenticationSlice.singpassToken);
  const resolveAttemptedRef = useRef(false);

  useRouterRedirection();

  useEffect(() => {
    if (!isAuthenticated || singPassType !== undefined || resolveAttemptedRef.current) {
      return;
    }
    resolveAttemptedRef.current = true;

    if (!singpassToken) {
      AppDispatch(resetAuthData());
      window.location.href = '/transfer/';
      return;
    }

    const timeoutId = window.setTimeout(() => {
      logoutAndRedirect(AppDispatch, SESSION_TIMEOUT_MESSAGE);
    }, RESOLVE_SINGPASS_TYPE_TIMEOUT_MS);

    AppDispatch(getSpcpName({ singpass_code: singpassToken }))
      .unwrap()
      .catch(() => {
        logoutAndRedirect(AppDispatch);
      })
      .finally(() => {
        clearTimeout(timeoutId);
      });
  }, [AppDispatch, isAuthenticated, singPassType, singpassToken]);

  return (
    <LottieLoader />
  )
}

export default Auth